import * as actionTypes from '../actionTypes';

export type ReduxAction = { type: string; payload?: any };
export function action(actionType: { TRIGGER: string }, payload?: any): ReduxAction {
  return {
    type: actionTypes.HANDLE_SAGA_EXCEPTION.TRIGGER,
    payload: { action: actionType, payload },
  };
}
